import React, { Component } from "react";
import PropTypes from "prop-types";

import { Link } from "react-router-dom";
import DropdownItemWrapperTag from "./DropdownItemWrapperTag";

import styles from "./NewNavigation.css";

class NewNavigationDropdownItem extends Component {
  constructor(props) {
    super(props);
  }

  makeProps(item) {
    if (!item.url) {
      return { tag: "button", className: styles.buttonItem };
    } else if (
      item.internal ||
      item.url.indexOf("https://www.axios.com") >= 0
    ) {
      return { tag: Link, to: item.url.replace("https://www.axios.com", "") };
    } else {
      return { tag: "a", href: item.url };
    }
  }

  render() {
    if (!this.props.items || this.props.items.length === 0) return null;
    if (this.props.isMobile)
      return (
        <div>
          <div className={styles.mobileSectionHeader}>{this.props.name}</div>
          <div className={styles.mobileList}>
            {this.props.items.map((item, index) => {
              const key = item.id || `${item.url}-${index}`;
              return (
                <DropdownItemWrapperTag
                  item={item}
                  key={key}
                  mobileToggle={this.props.mobileToggle}
                  {...this.makeProps(item)}
                />
              );
            })}
          </div>
        </div>
      );
  }
}

NewNavigationDropdownItem.proptypes = {
  items: PropTypes.array,
  isMobile: PropTypes.bool,
  mobileToggle: PropTypes.func,
};

export default NewNavigationDropdownItem;
